module.exports = __webpack_public_path__ + "static/media/index-gift-dialog-middle.d9bce78c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index-gift-dialog-middle.png
// module id = 1923
// module chunks = 6